import { render, staticRenderFns } from "./dataItem.vue?vue&type=template&id=08eb66d6&scoped=true"
import script from "./dataItem.vue?vue&type=script&lang=js"
export * from "./dataItem.vue?vue&type=script&lang=js"
import style0 from "./dataItem.vue?vue&type=style&index=0&id=08eb66d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08eb66d6",
  null
  
)

export default component.exports